<template>
    <Dialog class="p-dialog-maximized sheet-comments-dialog" v-model:visible="isVisible" :closable="false" :draggable="false">
		<template #header>
			<div class="row mb-3 col-md-12">
				<div class="row">
					<div class="col-md-8">
						<span class="p-dialog-title">
							Comments
						</span>
					</div>
					
					<div class="col-md-4">
						<div class="col-md-12 d-flex justify-content-end">
							<Button v-if="!isLoading && companyReportSheets.length > 0" label="Export" icon="pi pi-external-link" @click="exportSheetsComments"/>
							<Button class="p-dialog-header-icons" icon="pi pi-times" severity="secondary" text rounded @click="closeDialog" />
						</div>
					</div>
				</div>
			</div>
		</template>
		<div v-if="!isLoading">
			<div v-if="pageError == ''">
				<div v-for="(companyReportSheet, companyReportSheetIndex) in companyReportSheets" :key="companyReportSheetIndex">
					<div class="row col-md-12 mb-5">
						<div class="col-md-12">
							<h6>
								<span>{{ companyReportSheet.title.sheet }}</span>
								<span class="text-danger"> ID: {{ companyReportSheet.title.id }}</span>
							</h6>
						</div>
						<div class="col-md-12">
							<table class="w-100">
								<thead>
									<tr style="border-bottom: 2px solid #000000;">
										<th style="width: 7%; border-right: 2px solid #000000;"></th>
										<th>Comments</th>
										<th style="width: 15%;">Last Modified By</th>
										<th style="width: 18%;">Time</th>
									</tr>
								</thead>
								<tbody>
									<tr v-for="(sheetComment, sheetCommentIndex) in companyReportSheet.sheetComments" :key="sheetCommentIndex">
										<th style="border-right: 2px solid #000000;">{{ sheetComment.cell }}</th>
										<td>{{ getCommentValue(sheetComment.comment) }}</td>
										<td>{{ getCommentUsername(sheetComment.comment) }}</td>
										<td>{{ getCommentTime(sheetComment.comment) }}</td>
									</tr>
								</tbody>
							</table>
						</div>
					</div>
				</div>
			</div>

            <div v-if="pageError == '' && companyReportSheets.length == 0" style="height: 300px;" class="d-flex align-items-center">
				<div class="error-no-record">
					<FontAwesomeIcon :icon="['fas', 'image']" size="2x" />
					<h6><span>No Record Found</span></h6>
				</div>
			</div>

			<div v-if="pageError != ''" style="height: 300px;" class="d-flex justify-content-center align-items-center">
				<ThePageError @back-event="closeDialog" :pageError="pageError"></ThePageError>
			</div>
		</div>

		<div v-else>
			<TheTabViewLoading ></TheTabViewLoading>
		</div>
	</Dialog>
</template>
<script lang="ts">
    import { defineComponent } from 'vue';

    import ThePageError from "@/components/ThePageError.vue";
    import TheTabViewLoading from "@/components/TheTabViewLoading.vue";

    import companyReportSheetTemplateApi from "@/api/companyreportsheettemplate-api";

    import formulaMixin from "@/mixin/formula";
    import excelUtils from "@/mixin/utils/excel-utils";

    export default defineComponent({
        mixins: [formulaMixin, excelUtils],
        components: {
            ThePageError,
            TheTabViewLoading
        },
        data() {
            return {
                isVisible: false,
                isLoading: false,
                pageError: "",
				sheetType: null as any,
				templateIndex: null as any,
				companyReport: null as any,
                companyReportSheets: [] as any[],
            }
        },
        // props: {
		// 	sheetType: {
		// 		type: String,
		// 		required: true
		// 	},
		// 	templateIndex: {
		// 		type: Number,
		// 		required: true
		// 	},
        //     companyReport: {
        //         type: Object,
        //         required: true
        //     },
        // },
        methods: {
            showDialog(sheetType: any, templateIndex: any, companyReport: any) {
				this.isVisible = true;
				document.body.classList.add("dialog-open");

				this.sheetType = sheetType;
				this.templateIndex = templateIndex;
				this.companyReport = companyReport

				this.isLoading = true;
                this.pageError = "";
                this.companyReportSheets = [];

				companyReportSheetTemplateApi.companyReportSheetTemplateViewComments(this.sheetType, this.companyReport.identifier, this.templateIndex, {})
					.then(response => {
						this.companyReportSheets = response.data.companyReportSheets;
						this.isLoading = false;
					})
					.catch(error => {
						this.pageError = error;
						this.isLoading = false;
					});
			},
			closeDialog() {
				clearTimeout(this.companyReportSheetsTimeout);
				this.isVisible = false;
				document.body.classList.remove("dialog-open");
			},
            exportSheetsComments() {                
				let result = [] as any[];
				
				this.companyReportSheets.forEach((companyReportSheet: any) => {
					if (companyReportSheet.sheetComments.length > 0) {
						result.push([companyReportSheet.title.sheet + " ID:" + companyReportSheet.title.id]);
						result.push(['', 'Comments', 'Last Modified By', 'Time'])
						companyReportSheet.sheetComments.forEach((sheetComment: any) => {
							result.push([
								sheetComment.cell,
								this.getCommentValue(sheetComment.comment),
								this.getCommentUsername(sheetComment.comment),
								this.getCommentTime(sheetComment.comment)
							]);
						});
						result.push([]);
						result.push([]);
						result.push([]);
					}
				});

                let regional = null;
                if (this.companyReport.sheetType == 'CWK') {
                    regional = this.templateIndex == 1 ? 'local' : 'foreign';
                }

                let filename = '_' + this.companyReport.fileId + (regional != null ? '_' + regional  : '') + "_comments" + ".xlsx";

                this.downloadExcelFileWithArray(result, filename);
            },
			getCommentValue(comment: any) {
				if (comment == null) {
					return '';
				}
				if (typeof comment === 'string') {
					return comment;
				}
				return comment.value ?? '';
			},
			getCommentUsername(comment: any) {
				if (comment == null || typeof comment === 'string') {
					return '';
				}
				return comment.lastModifiedBy ?? '';
			},
			getCommentTime(comment: any) {
				if (comment == null || typeof comment === 'string') {
					return '';
				}
				return comment.time ?? '';
			},
        }
    });
</script>